import type Customer from './customer';
import { BaseEntity, JsonApiRelationship, JsonApiResource } from '../jsonapi-provider';

@JsonApiResource({
  type: 'client-tag',
})
export default class ClientTag extends BaseEntity {
  name: string = '';
  description: string = '';
  isActive: boolean = false;

  @JsonApiRelationship('customer') customers = new Array<Customer>();
}
